import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CostDetailsComponent } from '../components/cost-details/cost-details.component';

@Injectable({
  providedIn: 'root',
})
export class CostDetailsService {
  private dialogService = inject(DialogService);

  openCostDetails(): void {
    this.dialogService.open(CostDetailsComponent, {
      header: 'Cost Details',
      width: '70%',
      contentStyle: { 'max-height': '500px', overflow: 'auto' },
      baseZIndex: 10000,
      closable: true,
      draggable: true,
    });
  }
}
